import React from "react";
import LeadForm from "./LeadForm";

const ContactForm = () => {
  return (
    <LeadForm
      title="Get Unlimited IT Assist"
      subtitle="for as little as $19/month"
      source="contact-form"
    />
  );
};

export default ContactForm;
